// Minimal inline-Markdown renderer for CMS text.
// Currently supports **bold** — safe because we return React nodes (not innerHTML),
// so any user-typed HTML in the CMS remains escaped by React.

export function renderBold(text) {
    if (text === undefined || text === null || text === "") return text ?? null;
    const str = String(text);
    if (!str.includes("**")) return str;
    const parts = str.split(/(\*\*[^*]+\*\*)/g);
    return parts.map((p, i) =>
        /^\*\*[^*]+\*\*$/.test(p)
            ? <strong key={i}>{p.slice(2, -2)}</strong>
            : p
    );
}

// Strip **bold** markers, returning a plain string. Useful for meta tags,
// alt attributes, and any place that expects a raw string.
export function stripBold(text) {
    if (!text) return text ?? "";
    return String(text).replace(/\*\*([^*]+)\*\*/g, "$1");
}
